var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRecordIcon = function SvgRecordIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.746 3.166 2.056 2.09M14.012 2.39l1.306-1.285a.366.366 0 0 1 .519.005l2.056 2.09a.366.366 0 0 1-.004.518l-1.307 1.286M7.73 9.078l2.314 2.352",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.104 4.49-7.317 7.197-3.213.59.642-3.203 7.318-7.198",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.083 8.47v6.064a.466.466 0 0 1-.466.466H2.153a.466.466 0 0 1-.466-.466V1.472c0-.258.208-.467.466-.467h9.564",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
export default SvgRecordIcon;